import http from "@/apis/http";
import url from "@/config/url";

const api = url.tgBusiness.member.review;

export default {
  getData: (params) => http.post(api.search, params),
  getColumns: (params) => http.post(api.columns, params),
  action: {
    accept: (params) => http.post(api.action, { ...params, action: "accept" }),
    reject: (params) => http.post(api.action, { ...params, action: "reject" }),
    "accept-bulk": (params) =>
      http.post(api.action, { ...params, action: "accept-bulk" }),
    "reject-bulk": (params) =>
      http.post(api.action, { ...params, action: "reject-bulk" }),
    "accept-all": (params) =>
      http.post(api.action, { ...params, action: "accept-all" }),
    "reject-all": (params) =>
      http.post(api.action, { ...params, action: "reject-all" }),
  },
};
